import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { StatsBanner } from './components/StatsBanner';
import { Conditions } from './components/Conditions';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Comparison } from './components/Comparison';
import { UrgencyModule } from './components/UrgencyModule';
import { Pricing } from './components/Pricing';
import { ProSection } from './components/ProSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
const META_PIXEL_ID = '1024294170258306';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // If pixel was already initialized, just fire PageView and exit
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    // Bootstrap fbq queue (Meta Pixel stub)
    const n: any = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
    window._fbq = n;
    // Load fbevents.js — append to <head> directly to avoid parentNode issues
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Queue init + PageView (these run as soon as fbevents.js loads)
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-navy selection:bg-teal selection:text-white" data-id="element-0">
      {/* Noscript fallback pixel */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Testimonials data-id="element-5" />
        <PainPoints data-id="element-6" />
        <TargetAudience data-id="element-7" />
        <StatsBanner data-id="element-8" />
        <Conditions data-id="element-9" />
        <Tomos data-id="element-10" />
        <Bonos data-id="element-11" />
        <Comparison data-id="element-12" />
        <UrgencyModule variant="light" data-id="element-13" />
        <Pricing data-id="element-14" />
        <ProSection data-id="element-15" />
        <Guarantee data-id="element-16" />
        <FAQ data-id="element-17" />
        <UrgencyModule variant="dark" data-id="element-18" />
        <FinalCTA data-id="element-19" />
      </main>
      <Footer data-id="element-20" />

      {/* Social proof — verified purchase notifications */}
      <SocialProofPopup data-id="element-21" />
    </div>;
}